"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregationAction = void 0;
/**
 * 聚合操作
 */
var AggregationAction;
(function (AggregationAction) {
    AggregationAction["NONE"] = "none";
    AggregationAction["COUNT_ALL"] = "countAll";
    AggregationAction["COUNT_VALUE"] = "countValue";
    AggregationAction["COUNT_UNIQUE_VALUE"] = "countUniqueValue";
    AggregationAction["COUNT_EMPTY"] = "countEmpty";
    AggregationAction["COUNT_NOT_EMPTY"] = "countNotEmpty";
    AggregationAction["PERCENT_EMPTY"] = "percentEmpty";
    AggregationAction["PERCENT_NOT_EMPTY"] = "percentNotEmpty";
    AggregationAction["CHECKED"] = "checked";
    AggregationAction["UNCHECKED"] = "unchecked";
    AggregationAction["PERCENT_CHECKED"] = "percentChecked";
    AggregationAction["PERCENT_UNCHECKED"] = "percentUnchecked";
    AggregationAction["SUM"] = "sum";
    AggregationAction["AVERAGE"] = "average";
    AggregationAction["MAX"] = "max";
    AggregationAction["MIN"] = "min";
    AggregationAction["MEDIAN"] = "median";
    AggregationAction["RANGE"] = "range";
    AggregationAction["EARLIEST_DATE"] = "earliestDate";
    AggregationAction["LATEST_DATE"] = "latestDate";
    AggregationAction["DATE_RANGE"] = "dateRange";
    AggregationAction["SHOW_UNIQUE"] = "showUnique";
    AggregationAction["SHOW_ORIGIN"] = "showOrigin";
    AggregationAction["DEDUPLICATION"] = "deduplication";
})(AggregationAction = exports.AggregationAction || (exports.AggregationAction = {}));
